import React, { useEffect } from "react";
import { useState } from "react";
import Breadcrumb from "../../../components/common/Breadcrumb";

import { NavLink, useLocation, useNavigate, useParams } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { clearDatahandling } from "../../../utils/clearDataHandling";
import { getjobReview, jobDetailsById } from "../../../redux/reducers/jobsSlice";
import { extractIntoDDMMFormat } from "../../../utils/extractIntoDDMMFormat";
import { monthDay } from "../../../utils/monthDay";
import { formatTimeRange } from "../../../utils/formattedTimeRange";
import { fullDayFormat } from "../../../utils/fullDayFormat";
import RescheduleBox from "./RescheduleBox";
import { Rating } from "react-simple-star-rating";
import { setClearOrder } from "../../../redux/reducers/createOrderSlice";







const BookingDetails = () => {
  const { jobDetails, selectedjobReview } = useSelector((state) => state.jobs)
  const [showScheduleBox, setShowScheduleBox] = useState(false);
  const [selectedJobDetails, setSelectedJobDetails] = useState(null)
  const location = useLocation()
  let { id } = useParams();

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const calculateTimeDifference = () => {
    const startDate = new Date(jobDetails?.startDate);
    const presentTime = new Date();
    const timeDifference = startDate - presentTime;
    const hoursDifference = timeDifference / (1000 * 60 * 60);

    return hoursDifference > 24;
  };
  const [isWithin48Hours, setIsWithin48Hours] = useState(false);
  function handleMoreClick() {

  }
  useEffect(() => {
    if (id) {
      dispatch(jobDetailsById(id))
      dispatch(getjobReview(id))
    }

  }, [id])
  useEffect(() => {
    clearDatahandling(dispatch)

  }, [])

  // useEffect(() => {
  //   const intervalId = setInterval(() => {
  //     setIsWithin48Hours(calculateTimeDifference());
  //   }, 1000); // Update every second

  //   // Cleanup interval on component unmount
  //   return () => clearInterval(intervalId);
  // }, []);



  const rescheduleHandler = () => {
    setShowScheduleBox(!showScheduleBox)
    setSelectedJobDetails(jobDetails)
    dispatch(setClearOrder())
  }

  useEffect(() => {
    setIsWithin48Hours(calculateTimeDifference())

  }, [])
  return (
    <>
      <div className="booking-details-sec">
        <div className="booking-details-wrap max-720">
          <div className="upcoming-sec">
            <h2>My Bookings</h2>

            <div className="bre-wrap ">
              <Breadcrumb title={"Bookings"} id={`BOOKING ${jobDetails?.jobId}`} navigate={navigate} path={"/booking"} />
              <NavLink to="/booking">Back to My Bookings</NavLink>
            </div>

            <div className="booking-details-box">
              <div className="booling-id-wrap d-flex align-items-center">
                <div className="booling-id">Job:{jobDetails?.jobId}</div>

                <div className={`up-green ${jobDetails?.status === "Upcoming" && "up-yellow"} ${jobDetails?.status === "Cancelled" && "up-yellow up-red"}`}>
                  <p className="mb-0">{jobDetails?.status}</p>
                </div>
              </div>

              <div className="upcoming-heading-wrap ">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="cl-heading-wrap">
                    <div className="upcoming-heading">
                      <h5>

                        {`${jobDetails?.order_id?.orderType?.charAt(0).toUpperCase()}${jobDetails?.order_id?.orderType?.slice(1)} Cleaning`}
                        {/* <span class="up-count">{extractIntoDDMMFormat(jobDetails?.createdAt)}</span> */}
                      </h5>
                    </div>
                    <p className="mb-0">{monthDay(jobDetails?.startDate)} </p>
                    <p className="mb-0">{formatTimeRange(jobDetails?.startDate, jobDetails?.endDate)}</p>
                  </div>
                  <div className="up-green up-red">
                    {((jobDetails?.order_id?.orderType?.toLowerCase() === "general" || jobDetails?.order_id?.orderType?.toLowerCase() === "regular") && jobDetails?.status === 'Upcoming' && !jobDetails?.jobId.includes('R')) && (calculateTimeDifference()) ? (<p
                      className="mb-0 cursor-pointer"
                      onClick={rescheduleHandler}
                    >
                      RESCHEDULE
                    </p>
                    ) : <p
                      className="mb-0 cursor-pointer disabled-btn"
                    >
                      RESCHEDULE
                    </p>}
                  </div>
                </div>

                {showScheduleBox && (
                  <RescheduleBox showScheduleBox={showScheduleBox} setShowScheduleBox={setShowScheduleBox} selectedJobDetails={selectedJobDetails} setSelectedJobDetails={setSelectedJobDetails} />
                )}
              </div>

              <div className="service-row">
                <div className="row">
                  <div className="col-md-6">
                    <div className="service-row-col-wrap">
                      <h3>Job Details </h3>
                      <div className="sm-det">
                        <h5>Service Location</h5>
                        <p className={``}>{jobDetails?.order_id?.formatedAddress}<br />{jobDetails?.order_id?.address?.displayAddress?.unitNo} <br />Singapore {jobDetails?.order_id?.address?.displayAddress?.postalCode}<br /><h6 className={``}>{jobDetails?.order_id?.address?.displayAddress?.generalLocation}</h6></p>
                      </div>
                      <div className="sm-det">
                        <h5>Service Staff</h5>
                        {jobDetails?.assignTo && jobDetails?.assignTo?.length > 0 ? jobDetails?.assignTo?.map((assignToItem) => {
                          return (
                            <>

                              <p> {assignToItem?.staff_id?.name}</p>



                            </>
                          )
                        }) : null}
                      </div>
                      <div className="sm-det">
                        <h5>Additional Comment</h5>
                        <p> {jobDetails?.order_id?.additionalMessage}</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="service-row-col-wrap">
                      <h3>Services Booked</h3>
                      <div className="sm-det">
                        {jobDetails?.jobServiceArray
                          && jobDetails?.jobServiceArray
                            ?.length > 0 && jobDetails?.jobServiceArray
                              ?.map((itemService) => {
                                return (
                                  <>
                                    <div className="sm-det">

                                      <h5> {`${jobDetails?.order_id?.orderType?.charAt(0).toUpperCase()}${jobDetails?.order_id?.orderType?.slice(1)} Cleaning`}</h5>

                                      <p>
                                        {`${itemService?.priceDetails?.range ? `${itemService?.priceDetails?.range} Sqft` : itemService?.priceDetails?.hdbOptions ? `${itemService?.priceDetails?.hdbOptions} ${itemService?.priceDetails?.isTeltCovering && `(Telt Covering)`}` : (jobDetails?.order_id?.orderType?.toLowerCase() === "regular" || jobDetails?.order_id?.orderType.toLowerCase() === "general") ? ((jobDetails?.order_id?.orderType.toLowerCase() === 'general' || jobDetails?.order_id?.orderType.toLowerCase() === 'regular')) ? `${itemService?.orderDuration} hours` : '' : ""} `}

                                        {itemService?.selectedTimePrefence ? itemService?.selectedTimePrefence : null}
                                      </p>
                                    </div>

                                  </>
                                )
                              })}
                      </div>




                    </div>
                  </div>
                </div>
              </div>
              {selectedjobReview?.rating ? <div className={`details-review`}>
                <div>
                  <p className={`review-bold`}>Review</p>
                  <Rating initialValue={selectedjobReview?.rating} allowFraction size={15} readonly />
                </div>
                <div>
                  <p>{selectedjobReview?.review}</p>
                </div>
              </div> : null}
              <div className="det-bottom d-flex align-items-center justify-content-between">
                <p className="mb-0">Order ID: {jobDetails?.order_id?.orderId}</p>
                <p className="mb-0"> Order date: {fullDayFormat(jobDetails?.createdAt)}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}


export default BookingDetails;
